import React, { useEffect, useState } from "react";

const TechnoAEP = () => {
    return (
        <section id="techno-aep" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>TECHNO AEP</h2>

                <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '30px', fontFamily: 'Lora', textAlign: 'center' }}>
                    Techno Academic Enhancement Programme (AEP) - is our specialised programme, designed to provide additional academic support and enrichment opportunities for students.
                </p>

                <div className="row">
                    <div className="col-md-6 mb-4">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '10px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', fontFamily: 'Lora', textAlign: 'center' }}>Remedial Classes</h4>
                            <p className="tigps-main-techno-aep-p">Additional support for students, who need extra help in specific subjects, to ensure no one is left behind.</p>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '10px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', fontFamily: 'Lora', textAlign: 'center' }}>Advanced Learning</h4>
                            <p className="tigps-main-techno-aep-p">Enrichment programmes for high-achieving students, to challenge and extend their learning, beyond the regular curriculum.</p>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '10px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', fontFamily: 'Lora', textAlign: 'center' }}>Skill Development</h4>
                            <p className="tigps-main-techno-aep-p">Focus on developing 21st-century skills, including critical thinking, problem-solving, and digital literacy.</p>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '10px', height: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', fontFamily: 'Lora', textAlign: 'center' }}>Personalised Learning</h4>
                            <p className="tigps-main-techno-aep-p">Customized learning paths, based on individual student needs, learning styles, and academic goals.</p>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-md-6 mb-4">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '5px', borderRadius: '10px', height: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'center', border: '1px solid #fff'}}>
                            <a
                                href="/aep-digital-library"
                                rel="noopener noreferrer"
                            >
                                <h4 style={{ fontSize: '1.2rem', fontFamily: 'Lora', textAlign: 'center', color: '#fff' }}>Click here to open the AEP Digital Library</h4>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div style={{ background: 'rgba(255,255,255,0.1)', padding: '5px', borderRadius: '10px', height: '70px', display: 'flex', flexDirection: 'column', justifyContent: 'center', border: '1px solid #fff'}}>
                            <a
                                href="/aep-questions-hub"
                                rel="noopener noreferrer"
                            >
                                <h4 style={{ fontSize: '1.2rem', fontFamily: 'Lora', textAlign: 'center', color: '#fff' }}>Click here to open the AEP Question Hub</h4>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default TechnoAEP;
